export default __webpack_public_path__ + "static/media/harbolkick-category-streetwear.01a1d0f3.png";